// List of default dynamic variable available in the editor / landing page with {key} syntax
export const DYNAMIC_VARIABLES = [
  { key: 'extended_id', name: 'Code ID' },
  { key: 'product_description', name: 'Product Description' },
  { key: 'product_name', name: 'Product Name' },
  { key: 'product_sku', name: 'Product SKU' },
  { key: 'product_url', name: 'Product URL' },
  { key: 'product_image', name: 'Product Image' },
  { key: 'brand_name', name: 'Brand Name' },
  { key: 'scan_count', name: 'Scan Count' },
  { key: 'country', name: 'Scan Country' },
  { key: 'scan_id', name: 'Scan ID' },
  { key: 'serial_number', name: 'Serial Number' },
  { key: 'scan_result', name: 'Scan Result' },
  { key: 'api_key', name: 'API Key' }
]

// Built-in variables to hide from the editor, keyed by plan-id prefix.
// A plan hides a variable when its id starts with one of these prefixes.
// Add more keys per plan, or more plan prefixes, as new rules are needed.
export const PLAN_HIDDEN_VARIABLES = {
  'st-pro': ['brand_name']
}
